export const desktopNav = [
  { label: 'PROJECTS', href: '/projects' },
  { label: 'CAPABILITIES', type: 'mega' },
  { label: 'MATERIALS', href: '/materials', futurePath: '/materials' },
  { label: 'PROFESSIONALS', href: '/professionals', futurePath: '/professionals' },
  { label: 'FACTORY', href: '/factory', futurePath: '/factory' },
  { label: 'INSIGHTS', href: '/insights' },
  { label: 'ABOUT', href: '/about' },
];

export const capabilityMenu = [
  { number: '01', title: 'Turnkey Fit-Out', description: 'Technical coordination through to installed delivery.', href: '/capabilities/turnkey-fitout', image: 'https://files.ihgbrands.com/prastara/uploads/images/2ef2b9b2-1d06-4324-8c38-ce5e398857cb.webp' },
  { number: '02', title: 'Bespoke Joinery', description: 'Purpose-made elements, fabricated with detail in mind.', href: '/capabilities/bespoke-joinery', image: 'https://files.ihgbrands.com/prastara/uploads/images/f5ab7f29-3dc2-4988-a18d-03359a067b3d.webp' },
  { number: '03', title: 'Furnishing & Lifestyle', description: 'Furniture, textiles, surfaces and considered interiors.', href: '/capabilities/furnishing-lifestyle', image: 'https://files.ihgbrands.com/prastara/uploads/images/f738cefa-743d-4504-8a24-fc56948b5b93.webp' },
  { number: '04', title: 'Specialist Fabrication', description: 'Metal, glass, finishes and custom architectural elements.', href: '/capabilities/specialist-fabrication', image: 'https://files.ihgbrands.com/prastara/uploads/images/81508594-10cf-4705-99f5-30a801222373.webp' },
  { number: '05', title: 'Acoustic & Specialist Spaces', description: 'Performance-led solutions for environments with specific needs.', href: '/capabilities/acoustic-specialist-spaces', image: 'https://files.ihgbrands.com/prastara/uploads/images/4fce2b66-840a-4e81-9bbf-8bb36217e5ee.jpg' },
  { number: '06', title: 'Authority & Project Delivery', description: 'Drawings, approvals, production and precise handover.', href: '/capabilities/authority-project-delivery', image: 'https://files.ihgbrands.com/prastara/uploads/images/24263864-8aa7-4dd7-b626-6dc7f5faf741.jpg' },
];

export const materialCategories = [
  'Wood & Veneers', 'Laminates & Engineered Surfaces', 'Metals', 'Glass', 'Fabrics & Upholstery',
  'Acoustic Materials', 'Carpets & Flooring', 'Outdoor / Performance Materials', 'Decorative Surfaces & Wall Finishes',
];

export const professionalItems = [
  { label: 'Material Samples', href: '/professionals/request-materials' },
  { label: 'Technical Resources', href: '/professionals/resources' },
  { label: 'Send Drawings', href: '/professionals/send-drawings' },
  { label: 'Submit BOQ', href: '/professionals/submit-boq' },
  { label: 'Capability Documents', href: '/professionals/resources' },
  { label: 'Company Profile', href: '/professionals/resources' },
  { label: 'Project References', href: '/projects' },
  { label: 'BOQ Submission', href: '/professionals/submit-boq' },
  { label: 'Project Tools', href: '/professionals/project-tools' },
];

export const mobilePrimaryNav = [
  { label: 'Projects', href: '/projects' },
  { label: 'Materials', href: '/materials' },
  { label: 'Factory', href: '/factory' },
  { label: 'Insights', href: '/insights' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];